"use strict";

var _variants = require("./variants");
//# sourceMappingURL=stylesDefinition.js.map